import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { usePostPageEditor } from "../PostPageEditorContext";
import { PostPageTodoEditor } from "../PostPageEditors";
import PostPageTodoInternal from "./PostPageTodoInternal";
const PostPageTodo = (props)=>{
    var ref, ref1, ref2;
    const { todo , index , disabled  } = props;
    const { id  } = todo;
    const { state  } = usePostPageEditor();
    const openTodoNewEditor = state.editor === "CREATE_TODO" && state.editorPosition === id;
    const openTodoEditEditor = state.editor === "EDIT_TODO" && state.editorPosition === id;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            (!openTodoEditEditor || state.variant === "mobile") && /*#__PURE__*/ _jsx(PostPageTodoInternal, {
                todo: todo,
                index: index,
                disabled: disabled
            }),
            /*#__PURE__*/ _jsx(PostPageTodoEditor, {
                topicId: todo.id,
                todo: todo,
                open: openTodoEditEditor ? state.variant : undefined
            }),
            /*#__PURE__*/ _jsx(PostPageTodoEditor, {
                topicId: todo.id,
                open: openTodoNewEditor ? state.variant : undefined,
                parentId: (ref = todo.parentTopic) === null || ref === void 0 ? void 0 : ref.id,
                parentType: (ref1 = todo.parentTopic) === null || ref1 === void 0 ? void 0 : ref1.type,
                parentNodeId: (ref2 = todo.parentTopic) === null || ref2 === void 0 ? void 0 : ref2.nodeId,
                afterItemId: id
            })
        ]
    });
};
export default PostPageTodo;
